
import React, {useState} from "react";
import InitializePage from '../../lib/server/page'
import Header from "../../components/Layouts/Header";
import HomeFooter from '../../components/Layouts/HomeFooter.jsx';
import SubscribeNewsLetter from '../../components/common/subscribenewsletter.jsx';
import HeaderTag from '../../components/meta.jsx';
import { getHelpPage } from '../../lib/api/common.jsx';
import { textsWeb, getText } from '../../lib/utils/langTexts'



const Ayuda = ({helppagedata, menu, webTexts}) => {  
  const [activelink, setactivelink] = useState(helppagedata[0]?.id);
  const [dropdownText, setdropdownText] = useState(helppagedata[0]?.section);


  return (
    <>
        <Header page={'common'} menuSections={menu}/>
        <HeaderTag title="Eccediciones" description="Eccomics" />
        <div className="container innerpage main-container mt-60 ayuda">
            <h2 className="A-la-venta-esta-sema">Ayuda</h2>
            <div className="line4 line-mob"></div>
            <div className="faq-select-tab-mob">
               <div className="dropdown form-control btn2_cont tabmobiledropdown">
                  <button className="dropdown-toggle" type="button" id="tabmobiledropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {dropdownText}
                  </button>
                  <div className="dropdown-menu" aria-labelledby="tabmobiledropdownMenuButton">
                  {helppagedata && helppagedata?.map((helpsection, i) => {
                        return (
                            <a key={`helpsection_${i}`}  className="dropdown-item" href="#" onClick={() => {setactivelink(helpsection?.id); setdropdownText(helpsection?.section);}}>{helpsection?.section}</a>
                        )})
                    }
                  </div>
                </div>
            </div>
            <div className="clearfix"></div>
            <div className="line4"></div>
            <div className="row">
                <div className="col-3">
                    <div className="navbar navi2">
                        <ul className="nav navbar-nav nav-tabs" role="tablist">
                            {helppagedata && helppagedata?.map((helpsection, i) => {
                                return (
                                    <li key={`helpsection_${i}`} className={activelink===helpsection?.id?"nav-item active":"nav-item"} onClick={() => {setactivelink(helpsection?.id)}}><a className={activelink===helpsection?.id?"nav-link active":"nav-link"} data-toggle="tab" href={`#helpsection_${helpsection?.id}`}>{helpsection?.section}</a>{activelink == helpsection?.id && <i className="arrow2"></i>}</li>
                                )})
                            }
                        </ul>
                    </div>
                </div>
                <div className="col-9">
                    <div className="tab-content">
                        {helppagedata && helppagedata?.filter(helpsection=>helpsection?.id==activelink)?.map((helpsection, i) => 
                        {
                            return(
                                <div id={`helpsection_${helpsection?.id}`} className={activelink===helpsection?.id?"tab-pane active show":"tab-pane"} role="tabpanel" key={`helpsection_${i}`}>
                                    <div id="accordion" className="accordion">
                                        <div className="card1 mb-0">
                                        {helpsection.qa.map((qa, index)=> {
                                             return(
                                                <div className="collapse-details"  key={`helpsectionqa_${index}`}>
                                                <div className={"collapsed col_wrap"} data-toggle="collapse" href={`#helpsectionqa_${index}`} aria-expanded="false">
                                                    <a className="card-title1" >{qa?.question}</a>
                                                </div>
                                                <div id={`helpsectionqa_${index}`} className="card-body1 collapse" data-parent="#accordion">
                                                    <div dangerouslySetInnerHTML={{ __html:qa?.answer}}></div>                              
                                                </div>
                                                </div>
                                            );
                                            })}
                                            
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
        <div className="container line-container">
           <div className="line6"></div>
        </div>
        <SubscribeNewsLetter webTexts={webTexts}/>
        <HomeFooter />
    </>
  );
};

async function loadData(context){                  
    const helppage = await getHelpPage();        
    const props = {helppagedata: helppage?.data}
       
    return props
}

export async function getStaticProps(context) {    
    return InitializePage(context,loadData, true)
}


export default Ayuda;
